import { render } from "./reg-status.vue?vue&type=template&id=26b35170&scoped=true"
import script from "./reg-status.vue?vue&type=script&lang=js"
export * from "./reg-status.vue?vue&type=script&lang=js"

import "./reg-status.vue?vue&type=style&index=0&id=26b35170&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b35170"]])

export default __exports__